import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
export function MemberManagement() {
  const [activeTab, setActiveTab] = useState<'list' | 'add'>('list');
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    photo: '',
    fullName: '',
    fatherName: '',
    spouseName: '',
    nid: '',
    birthCertNo: '',
    profession: '',
    age: '',
    education: '',
    division: '',
    district: '',
    upazila: '',
    union: '',
    village: '',
    range: '',
    station: '',
    bloodGroup: '',
    nidAttachment: '',
    birthCertAttachment: '',
    educationAttachment: ''
  });
  const stationsByRange: Record<string, string[]> = {
    Satkhira: ['Burigoalini Station', 'Kaikhali Station', 'Dobeki Station'],
    Khulna: ['Nalian Station', 'Patkosta Station', 'Karamjal Station'],
    Chandpai: ['Harbaria Station', 'Joymoni Station', 'Tamulbunia Station'],
    Sarankhola: ['Supati Station', 'Sharankhola Station', 'Kotka Station']
  };
  const members = [{
    photo: '👤',
    name: 'Abdur Rahman',
    email: 'abdur@member.com',
    idNumber: 'MBR-001',
    phone: '01711111111',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Jalal Uddin',
    email: 'jalal@member.com',
    idNumber: 'MBR-002',
    phone: '01822222222',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Rina Begum',
    email: 'rina@member.com',
    idNumber: 'MBR-003',
    phone: '01933333333',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Kamrul Hasan',
    email: 'kamrul@member.com',
    idNumber: 'MBR-004',
    phone: '01644444444',
    status: 'pending' as const
  }, {
    photo: '👤',
    name: 'Shirin Akter',
    email: 'shirin@member.com',
    idNumber: 'MBR-005',
    phone: '01555555555',
    status: 'approved' as const
  }];
  const columns = [{
    key: 'photo',
    label: 'Photo',
    render: (value: string) => <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center text-xl" data-id="element-1241">
          {value}
        </div>
  }, {
    key: 'name',
    label: 'Name'
  }, {
    key: 'email',
    label: 'Email ID'
  }, {
    key: 'idNumber',
    label: 'ID Number'
  }, {
    key: 'phone',
    label: 'Phone Number'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-1242" />
  }];
  const filters = [{
    key: 'status',
    label: 'Status',
    options: ['Approved', 'Pending', 'Rejected']
  }];
  const wizardSteps = [{
    title: 'Personal Info',
    description: 'Enter member personal information'
  }, {
    title: 'Address Details',
    description: 'Enter address details'
  }, {
    title: 'Documents',
    description: 'Upload required documents'
  }, {
    title: 'Review & Submit',
    description: 'Review all information before submitting'
  }];
  return <div className="space-y-6" data-id="element-1243">
      <div data-id="element-1244">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1245">Member Management</h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-1246">
          Manage conservation group members
        </p>
      </div>

      <div className="border-b border-gray-200" data-id="element-1247">
        <div className="flex gap-4" data-id="element-1248">
          <button onClick={() => setActiveTab('list')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'list' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1249">
            Member List
          </button>
          <button onClick={() => setActiveTab('add')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'add' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1250">
            Add Member
          </button>
        </div>
      </div>

      {activeTab === 'list' && <DataTable columns={columns} data={members} filters={filters} onView={row => console.log('View', row)} onEdit={row => console.log('Edit', row)} onDelete={row => console.log('Delete', row)} searchPlaceholder="Search members..." data-id="element-1251" />}

      {activeTab === 'add' && <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      if (!formData.fullName || !formData.nid) {
        alert('Please fill in all required fields.');
        return;
      }
      alert(`Member ${formData.fullName} registered successfully!`);
      setCurrentStep(0);
      setActiveTab('list');
      setFormData({
        photo: '',
        fullName: '',
        fatherName: '',
        spouseName: '',
        nid: '',
        birthCertNo: '',
        profession: '',
        age: '',
        education: '',
        division: '',
        district: '',
        upazila: '',
        union: '',
        village: '',
        range: '',
        station: '',
        bloodGroup: '',
        nidAttachment: '',
        birthCertAttachment: '',
        educationAttachment: ''
      });
    }} data-id="element-1252">
          {currentStep === 0 && <div className="space-y-4" data-id="element-1253">
              <div className="grid grid-cols-2 gap-4" data-id="element-1254">
                <div data-id="element-1255">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1256">
                    Photo Upload
                  </label>
                  <input type="file" accept="image/*" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1257" />
                </div>
                <div data-id="element-1258">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1259">
                    Full Name *
                  </label>
                  <input type="text" required value={formData.fullName} onChange={e => setFormData({
              ...formData,
              fullName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1260" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1261">
                <div data-id="element-1262">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1263">
                    Father's Name
                  </label>
                  <input type="text" value={formData.fatherName} onChange={e => setFormData({
              ...formData,
              fatherName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1264" />
                </div>
                <div data-id="element-1265">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1266">
                    Spouse Name
                  </label>
                  <input type="text" value={formData.spouseName} onChange={e => setFormData({
              ...formData,
              spouseName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1267" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1268">
                <div data-id="element-1269">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1270">
                    NID Number *
                  </label>
                  <input type="text" required value={formData.nid} onChange={e => setFormData({
              ...formData,
              nid: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1271" />
                </div>
                <div data-id="element-1272">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1273">
                    Birth Certificate No.
                  </label>
                  <input type="text" value={formData.birthCertNo} onChange={e => setFormData({
              ...formData,
              birthCertNo: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1274" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-1275">
                <div data-id="element-1276">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1277">
                    Profession
                  </label>
                  <input type="text" value={formData.profession} onChange={e => setFormData({
              ...formData,
              profession: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1278" />
                </div>
                <div data-id="element-1279">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1280">
                    Age
                  </label>
                  <input type="number" value={formData.age} onChange={e => setFormData({
              ...formData,
              age: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1281" />
                </div>
                <div data-id="element-1282">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1283">
                    Education
                  </label>
                  <input type="text" value={formData.education} onChange={e => setFormData({
              ...formData,
              education: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1284" />
                </div>
              </div>
            </div>}

          {currentStep === 1 && <div className="space-y-4" data-id="element-1285">
              <div className="grid grid-cols-2 gap-4" data-id="element-1286">
                <div data-id="element-1287">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1288">
                    Division
                  </label>
                  <select value={formData.division} onChange={e => setFormData({
              ...formData,
              division: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1289">
                    <option value="" data-id="element-1290">Select Division</option>
                    <option value="Khulna" data-id="element-1291">Khulna</option>
                    <option value="Barisal" data-id="element-1292">Barisal</option>
                    <option value="Dhaka" data-id="element-1293">Dhaka</option>
                    <option value="Chattogram" data-id="element-1294">Chattogram</option>
                    <option value="Rajshahi" data-id="element-1295">Rajshahi</option>
                    <option value="Rangpur" data-id="element-1296">Rangpur</option>
                    <option value="Sylhet" data-id="element-1297">Sylhet</option>
                    <option value="Mymensingh" data-id="element-1298">Mymensingh</option>
                  </select>
                </div>
                <div data-id="element-1299">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1300">
                    District
                  </label>
                  <select value={formData.district} onChange={e => setFormData({
              ...formData,
              district: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1301">
                    <option value="" data-id="element-1302">Select District</option>
                    <option value="Satkhira" data-id="element-1303">Satkhira</option>
                    <option value="Khulna" data-id="element-1304">Khulna</option>
                    <option value="Bagerhat" data-id="element-1305">Bagerhat</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1306">
                <div data-id="element-1307">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1308">
                    Upazila
                  </label>
                  <select value={formData.upazila} onChange={e => setFormData({
              ...formData,
              upazila: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1309">
                    <option value="" data-id="element-1310">Select Upazila</option>
                    <option value="Shyamnagar" data-id="element-1311">Shyamnagar</option>
                    <option value="Koyra" data-id="element-1312">Koyra</option>
                    <option value="Dacope" data-id="element-1313">Dacope</option>
                    <option value="Mongla" data-id="element-1314">Mongla</option>
                    <option value="Sarankhola" data-id="element-1315">Sarankhola</option>
                  </select>
                </div>
                <div data-id="element-1316">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1317">
                    Union
                  </label>
                  <select value={formData.union} onChange={e => setFormData({
              ...formData,
              union: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1318">
                    <option value="" data-id="element-1319">Select Union</option>
                    <option value="Burigoalini" data-id="element-1320">Burigoalini</option>
                    <option value="Gabura" data-id="element-1321">Gabura</option>
                    <option value="Munshiganj" data-id="element-1322">Munshiganj</option>
                    <option value="Koyra" data-id="element-1323">Koyra</option>
                    <option value="Dacope" data-id="element-1324">Dacope</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1325">
                <div data-id="element-1326">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1327">
                    Village
                  </label>
                  <select value={formData.village} onChange={e => setFormData({
              ...formData,
              village: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1328">
                    <option value="" data-id="element-1329">Select Village</option>
                    <option value="Munshiganj" data-id="element-1330">Munshiganj</option>
                    <option value="Gabura" data-id="element-1331">Gabura</option>
                    <option value="Shyamnagar" data-id="element-1332">Shyamnagar</option>
                    <option value="Koyra" data-id="element-1333">Koyra</option>
                    <option value="Dacope" data-id="element-1334">Dacope</option>
                  </select>
                </div>
                <div data-id="element-1335">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1336">
                    Range
                  </label>
                  <select value={formData.range} onChange={e => setFormData({
              ...formData,
              range: e.target.value,
              station: ''
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1337">
                    <option value="" data-id="element-1338">Select Range</option>
                    <option value="Satkhira" data-id="element-1339">Satkhira</option>
                    <option value="Khulna" data-id="element-1340">Khulna</option>
                    <option value="Chandpai" data-id="element-1341">Chandpai</option>
                    <option value="Sarankhola" data-id="element-1342">Sarankhola</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1343">
                <div data-id="element-1344">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1345">
                    Station
                  </label>
                  <select value={formData.station} onChange={e => setFormData({
              ...formData,
              station: e.target.value
            })} disabled={!formData.range} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20] disabled:bg-gray-100 disabled:text-gray-400" data-id="element-1346">
                    <option value="" data-id="element-1347">
                      {formData.range ? 'Select Station' : 'Select Range first'}
                    </option>
                    {formData.range && stationsByRange[formData.range]?.map(station => <option key={station} value={station} data-id="element-1348">
                          {station}
                        </option>)}
                  </select>
                </div>
                <div data-id="element-1349">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1350">
                    Blood Group
                  </label>
                  <select value={formData.bloodGroup} onChange={e => setFormData({
              ...formData,
              bloodGroup: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1351">
                    <option value="" data-id="element-1352">Select Blood Group</option>
                    <option value="A+" data-id="element-1353">A+</option>
                    <option value="A-" data-id="element-1354">A-</option>
                    <option value="B+" data-id="element-1355">B+</option>
                    <option value="B-" data-id="element-1356">B-</option>
                    <option value="AB+" data-id="element-1357">AB+</option>
                    <option value="AB-" data-id="element-1358">AB-</option>
                    <option value="O+" data-id="element-1359">O+</option>
                    <option value="O-" data-id="element-1360">O-</option>
                  </select>
                </div>
              </div>
            </div>}

          {currentStep === 2 && <div className="space-y-4" data-id="element-1361">
              <div data-id="element-1362">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1363">
                  NID Copy *
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1364" />
              </div>
              <div data-id="element-1365">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1366">
                  Birth Certificate Copy
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1367" />
              </div>
              <div data-id="element-1368">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1369">
                  Education Certificate
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1370" />
              </div>
            </div>}

          {currentStep === 3 && <div className="space-y-6" data-id="element-1371">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1372">
                <div className="flex items-center justify-between mb-3" data-id="element-1373">
                  <h4 className="font-semibold text-gray-900" data-id="element-1374">
                    Personal Information
                  </h4>
                  <button onClick={() => setCurrentStep(0)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1375">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1376">
                  <div data-id="element-1377">
                    <span className="text-gray-600" data-id="element-1378">Name:</span>{' '}
                    <span className="font-medium" data-id="element-1379">
                      {formData.fullName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1380">
                    <span className="text-gray-600" data-id="element-1381">NID:</span>{' '}
                    <span className="font-medium" data-id="element-1382">
                      {formData.nid || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1383">
                    <span className="text-gray-600" data-id="element-1384">Profession:</span>{' '}
                    <span className="font-medium" data-id="element-1385">
                      {formData.profession || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1386">
                <div className="flex items-center justify-between mb-3" data-id="element-1387">
                  <h4 className="font-semibold text-gray-900" data-id="element-1388">
                    Address Details
                  </h4>
                  <button onClick={() => setCurrentStep(1)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1389">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1390">
                  <div data-id="element-1391">
                    <span className="text-gray-600" data-id="element-1392">Division:</span>{' '}
                    <span className="font-medium" data-id="element-1393">
                      {formData.division || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1394">
                    <span className="text-gray-600" data-id="element-1395">District:</span>{' '}
                    <span className="font-medium" data-id="element-1396">
                      {formData.district || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1397">
                    <span className="text-gray-600" data-id="element-1398">Upazila:</span>{' '}
                    <span className="font-medium" data-id="element-1399">
                      {formData.upazila || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1400">
                    <span className="text-gray-600" data-id="element-1401">Union:</span>{' '}
                    <span className="font-medium" data-id="element-1402">
                      {formData.union || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1403">
                    <span className="text-gray-600" data-id="element-1404">Village:</span>{' '}
                    <span className="font-medium" data-id="element-1405">
                      {formData.village || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1406">
                    <span className="text-gray-600" data-id="element-1407">Range:</span>{' '}
                    <span className="font-medium" data-id="element-1408">
                      {formData.range || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1409">
                    <span className="text-gray-600" data-id="element-1410">Station:</span>{' '}
                    <span className="font-medium" data-id="element-1411">
                      {formData.station || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
            </div>}
        </WizardForm>}
    </div>;
}